import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ZenithLogo from '../assets/Logo.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faPalette, faSearchDollar, faChevronDown, faServer, faDatabase, faCode, faMobile, faGlobe, faCloud } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 20px 0;
  transition: all 0.3s ease-in-out;
  background: ${({ scrolled, location }) => scrolled ? '#ffffff' : (location === '/' ? `linear-gradient(125deg, #ffffff1c, #00000047)` : '')};  
  box-shadow: ${({ scrolled, location }) => scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : (location === '/' ? 'inset 0 4px 36px 0px #ced7e3' : '' )};
  
  @media (max-width: 768px) {
    padding: 15px 0;
    }
    
    @media (max-width: 576px) {
      padding: 12px 0;
      }
      `;
      
const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 100vw;
  
  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const Logo = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${({ scrolled }) => scrolled ? '#333' : '#fff'};
  align-items: center;
  gap: 15px;
  display: flex;
  span {
    color: #ff6e6e;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    gap: 10px;
  }
  
  @media (max-width: 576px) {
    font-size: 22px;
  }
  
  img {
    @media (max-width: 576px) {
      max-width: 200px;
      height: 70px;
      height: auto;
    }
  }
`;

const NavMenu = styled.nav`
  display: flex;
  align-items: center;
  margin-left: 50px;
  
  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: ${({ isOpen }) => isOpen ? '0' : '-100%'};
    width: 280px;
    height: 100vh;
    background-color: #fff;
    flex-direction: column;
    align-items: flex-start;
    padding: 80px 20px 30px;
    transition: all 0.4s ease-in-out;
    box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1);
    margin-left: 0;
    overflow-y: auto;
  }
  
  @media (max-width: 576px) {
    width: 250px;
    padding: 70px 15px 30px;
  }
`;

const NavItem = styled.a`
  margin: 0 15px;
  color: ${({ scrolled }) => scrolled ? '#333' : '#fff'};
  font-weight: 500;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  
  &:hover {
    color: #ff6e6e;
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #ff6e6e;
    transition: width 0.3s ease;
  }
  
  &:hover:after {
    width: 100%;
  }
  
  @media (max-width: 992px) {
    margin: 10px 0;
    color: #333;
  }
  
  @media (max-width: 576px) {
    font-size: 15px;
    margin: 8px 0;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  margin: 0 15px;
  
  &:hover > div {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  
  @media (max-width: 992px) {
    margin: 10px 0;
    width: 100%;
  }
  
  @media (max-width: 576px) {
    margin: 8px 0;
    margin-bottom: ${({ isOpen }) => isOpen? '50px' : '' };
  }
`;

const DropdownButton = styled.div`
  display: flex;
  align-items: center;
  color: ${({ scrolled }) => scrolled ? '#333' : '#fff'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    color: #ff6e6e;
  }
  
  svg {
    margin-left: 5px;
    font-size: 12px;
    transition: transform 0.3s ease;
  }
  
  @media (max-width: 992px) {
    color: #333;
    width: 100%;
    justify-content: space-between;
  }
  
  @media (max-width: 576px) {
    font-size: 15px;
  }
`;

const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  top: 40px;
  background-color: #fff;
  min-width: 300px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 10px 0;
  z-index: 1;
  opacity: ${({ isOpen }) => isOpen ? '1' : '0'};
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
  transform: ${({ isOpen }) => isOpen ? 'translateY(0)' : 'translateY(10px)'};
  transition: all 0.3s ease;
  
  @media (max-width: 992px) {
    position: relative;
    box-shadow: none;
    min-width: 100%;
    padding: ${({ isOpen }) => isOpen ? '0 0 0 15px' : '0'};
    margin-top: ${({ isOpen }) => isOpen ? '-30px' : '0'};
    height: ${({ isOpen }) => isOpen ? 'auto' : '0'};
    overflow: hidden;
  }
  
  @media (max-width: 576px) {
    padding: ${({ isOpen }) => isOpen ? '0 0 0 10px' : '0'};
  }
`;

const DropdownItem = styled.a`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #f8f8f8;
    color: #ff6e6e;
  }
  
  .icon-container {
    width: 36px;
    height: 36px;
    background-color: rgba(255, 94, 20, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    color: #ff6e6e;
    transition: all 0.3s ease;
  }
  
  &:hover .icon-container {
    background-color: #ff6e6e;
    color: #fff;
  }
  
  .service-name {
    font-weight: 500;
  }
  
  @media (max-width: 992px) {
    padding: 12px 0;
  }
  
  @media (max-width: 576px) {
    padding: 10px 0;
    font-size: 14px;
    
    .icon-container {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      font-size: 14px;
    }
  }
`;

const MobileMenuToggle = styled.div`
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ scrolled }) => scrolled ? '#333' : '#fff'};
  z-index: 1001;
  margin-left: auto;
  padding-right: 30px;
  
  @media (max-width: 992px) {
    display: block;
  }
  
  @media (max-width: 576px) {
    font-size: 22px;
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [currentLocation, setCurrentLocation] = useState('/');

  const location = useLocation();

  useEffect(() => {
    setCurrentLocation(location.pathname);
  }, [location]);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdown(null);
  };
  
  // For mobile view only
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };
  
  // Close mobile menu and dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only apply this for mobile view
      if (window.innerWidth <= 992 && isMenuOpen) {
        // Check if click is outside the mobile menu
        const navMenu = document.querySelector('nav');
        if (navMenu && !navMenu.contains(event.target) && !event.target.closest('.mobile-menu-toggle')) {
          setIsMenuOpen(false);
          setOpenDropdown(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);
  
  // Function to close menu when a service item is clicked
  const handleServiceItemClick = () => {
    if (window.innerWidth <= 992) {
      setIsMenuOpen(false);
      setOpenDropdown(null);
    }
  };
  
  return (
    <HeaderContainer scrolled={scrolled} location={currentLocation}>
      <HeaderContent>
        <Logo scrolled={scrolled}>
          <img src={ZenithLogo} alt="ZenitechSol" width='auto' height='50px' />
        </Logo>
        <NavMenu isOpen={isMenuOpen}>
          <NavItem href="/" scrolled={scrolled}>Home</NavItem>
          <NavItem href="/about-us" scrolled={scrolled}>About Us</NavItem>
          
          <DropdownContainer isOpen={openDropdown === 'services'}>
            <DropdownButton scrolled={scrolled} onClick={() => toggleDropdown('services')}>
              Our Services
              <FontAwesomeIcon icon={faChevronDown} style={{ transform: openDropdown === 'services' ? 'rotate(180deg)' : 'rotate(0)' }} />
            </DropdownButton>
            <DropdownContent isOpen={openDropdown === 'services'}>
              {/* Server Services */}
              <DropdownItem href="/services/server-setup" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faServer} />
                </div>
                <span className="service-name">Server Setup</span>
              </DropdownItem>
              <DropdownItem href="/services/server-maintenance" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faServer} />
                </div>
                <span className="service-name">Server Maintenance</span>
              </DropdownItem>
              <DropdownItem href="/services/cloud-support" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faCloud} />
                </div>
                <span className="service-name">Cloud Support</span>
              </DropdownItem>
              
              {/* Data Services */}
              <DropdownItem href="/services/database-management" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faDatabase} />
                </div>
                <span className="service-name">Database Management</span>
              </DropdownItem>

              {/* Data Services */}
              <DropdownItem href="/services/ui-ux-design" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faPalette} />
                </div>
                <span className="service-name">UI / UX Design</span>
              </DropdownItem>

              {/* Data Services */}
              <DropdownItem href="/services/seo-optimization" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faSearchDollar} />
                </div>
                <span className="service-name">SEO Optimization</span>
              </DropdownItem>
              
              {/* Development Services */}
              <DropdownItem href="/services/software-development" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faCode} />
                </div>
                <span className="service-name">Software Development</span>
              </DropdownItem>
              <DropdownItem href="/services/mobile-app-development" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faMobile} />
                </div>
                <span className="service-name">Mobile App Development</span>
              </DropdownItem>
              <DropdownItem href="/services/website-development" onClick={handleServiceItemClick}>
                <div className="icon-container">
                  <FontAwesomeIcon icon={faGlobe} />
                </div>
                <span className="service-name">Website Development</span>
              </DropdownItem>
            </DropdownContent>
          </DropdownContainer>

          <NavItem href="/contact-us" scrolled={scrolled}>Contact Us</NavItem>
        </NavMenu>
        
        <MobileMenuToggle scrolled={scrolled} onClick={toggleMenu} className="mobile-menu-toggle">
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </MobileMenuToggle>

      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;